import { containerTransportOrder } from "./containerTransportOrder";
import { containerTransportGrid } from "./containerTransportGrid";
import { location } from "./location";

const base = {
	projectTitle: "MOVE Portal",
	navigation_NewOrder: "New Order",
	navigation_GetEstimate: "Get Estimate",
	...location,
	...containerTransportOrder,
	...containerTransportGrid
};

export { base };
